import React from "react";
import Styles from "./CompanyDetails.module.css";

const Field = ({ label, value, mono, muted, link, span, wrap, title }) => (
  <div className={`${Styles.field} ${span ? Styles.fieldSpan : ""}`}>
    <span className={Styles.fieldLabel}>{label}</span>
    <span
      className={`${Styles.fieldValue} ${mono ? Styles.fieldMono : ""} ${
        muted || !value || value === "-" ? Styles.fieldMuted : ""
      } ${link ? Styles.fieldLink : ""} ${wrap ? Styles.fieldValueWrap : ""}`}
      title={title}
    >
      {value || "—"}
    </span>
  </div>
);

const InfoCard = ({ title, children }) => (
  <div className={Styles.infoCard}>
    <div className={Styles.cardHeader}>
      <span className={Styles.cardTitle}>{title}</span>
    </div>
    <div className={Styles.cardBody}>{children}</div>
  </div>
);

const CompanyMainDetails = ({ company }) => {
  const bank = company?.companyBankAccount;
  const office = company?.companyOfficeAddress;
  const corr = company?.companyCorrespondenceAddress;

  const metrics = [
    {
      label: "Member ID",
      value: company?.memberId,
      sub: company?.categoryName || "Member",
      accent: true,
    },
    {
      label: "Registered",
      value: company?.registeredAt,
      sub: "Active account",
      accent: true,
    },
    {
      label: "PAN Number",
      value: company?.pan,
      sub: "Permanent acct",
      mono: true,
      accent: true,
    },
    {
      label: "TAN Number",
      value: company?.tan,
      sub: "Tax deduction acct",
      mono: true,
      accent: true,
    },
    {
      label: "GST Number",
      value: company?.gst,
      sub: "Goods & services tax",
      mono: true,
      accent: true,
    },
    {
      label: "Trading Licence",
      value: company?.tradingLicenseNumber,
      sub: "N/A",
      mono: true,
      accent: false,
    },
  ];

  return (
    <div className={Styles.mainDetailsWrapper}>
      {/* ── Metric cards ── */}
      <div className={Styles.metricCards}>
        {metrics.map((m) => (
          <div
            key={m.label}
            className={`${Styles.metricCard} ${m.accent ? Styles.metricCardAccent : Styles.metricCardNa}`}
          >
            <div className={Styles.metricCardLabel}>{m.label}</div>
            <div
              className={`${Styles.metricCardValue} ${m.mono ? Styles.metricCardMono : ""} ${!m.value ? Styles.metricCardNaValue : ""}`}
            >
              {m.value || "Not available"}
            </div>
            <div className={Styles.metricCardSub}>{m.sub}</div>
          </div>
        ))}
      </div>

      {/* ── Company Details card ── */}
      <InfoCard title="Company Details">
        <div className={Styles.fieldGrid}>
          <Field label="Username" value={company?.companyAdminUserName} />
          <Field label="Reg. Date" value={company?.registeredAt} />
          <Field label="Category" value={company?.categoryName} />
          <Field label="GST" value={company?.gst} mono />
          <Field label="PAN" value={company?.pan} mono />
          <Field label="TAN" value={company?.tan} mono />
          <Field
            label="Trading Lic."
            value={company?.tradingLicenseNumber}
            muted={!company?.tradingLicenseNumber}
          />
          {company?.description && (
            <div className={`${Styles.field} ${Styles.fieldSpan}`}>
              <span className={Styles.fieldLabel}>Description</span>
              <span className={Styles.fieldValue}>{company.description}</span>
            </div>
          )}
        </div>
      </InfoCard>

      {/* ── Bank Details card ── */}
      <InfoCard title="Bank Details">
        <div className={Styles.fieldGrid}>
          <Field label="Bank Name" value={bank?.bankName} />
          <Field label="Payee Name" value={bank?.payee} muted={!bank?.payee} />
          <Field label="Account Number" value={bank?.accountNumber} mono />
          <Field
            label="Bank Address"
            value={bank?.branchAddress}
            title={bank?.branchAddress}
          />
          <Field label="IFSC Code" value={bank?.ifscCode} mono />
        </div>
      </InfoCard>

      {/* ── Address cards ── */}
      <div className={Styles.addrGrid}>
        <InfoCard title="Office Address">
          <div className={Styles.fieldGrid}>
            <div className={`${Styles.field} ${Styles.fieldSpan}`}>
              <span className={Styles.fieldLabel}>Address</span>
              <span className={`${Styles.fieldValue} ${Styles.fieldValueWrap}`}>
                {office?.address || "—"}
              </span>
            </div>
            <Field label="Pincode" value={office?.pinCode} />
            <Field label="City" value={office?.cityName} />
            <Field label="State" value={office?.stateUtName} />
            <Field label="Contact" value={office?.contactPersonName} wrap />
            <Field
              label="Email"
              value={office?.email}
              link={!!office?.email}
              span
            />
            <Field label="Mobile" value={office?.mobileNumber} />
            <Field label="Alt. Mobile" value={office?.alternateMobileNumber} />
          </div>
        </InfoCard>

        <InfoCard title="Correspondence Address">
          <div className={Styles.fieldGrid}>
            <div className={`${Styles.field} ${Styles.fieldSpan}`}>
              <span className={Styles.fieldLabel}>Address</span>
              <span className={`${Styles.fieldValue} ${Styles.fieldValueWrap}`}>
                {corr?.address || "—"}
              </span>
            </div>
            <Field label="Pincode" value={corr?.pinCode} />
            <Field label="City" value={corr?.cityName} />
            <Field label="State" value={corr?.stateUtName} />
            <Field label="Contact" value={corr?.contactPersonName} wrap />
            <Field
              label="Email"
              value={corr?.email}
              link={!!corr?.email}
              span
            />
            <Field label="Mobile" value={corr?.mobileNumber} />
            <Field label="Alt. Mobile" value={corr?.alternateMobileNumber} />
          </div>
        </InfoCard>
      </div>
    </div>
  );
};

export default CompanyMainDetails;
